import React from "react";
import globalState from "globalState";

import endPoints from "./endPoints";
import { fetcher } from "./tools";

const inProgressMap = {};

const useGenericFetch = (key, params) => {
  const depsAsString = ((params && Object.values(params)) || []).join();
  const state = globalState();
  const cache = state.cache.get();

  const data = cache[key + depsAsString];

  const [error, setError] = React.useState();

  React.useEffect(() => {
    const isLoading = inProgressMap[key + depsAsString];
    if (data === undefined && !isLoading) {
      inProgressMap[key + depsAsString] = true;

      fetcher(endPoints[key], params)
        .then((res) => {
          state.cache.set((oldCache) => ({
            ...oldCache,
            [key + depsAsString]: res,
          }));
        })
        .catch((err) => {
          if (err.message === "no params") {
            state.cache.set((oldCache) => {
              const { [key + depsAsString]: old, ...rest } = oldCache;
              return rest;
            });
          } else {
            state.cache.set((oldCache) => ({
              ...oldCache,
              [key + depsAsString]: null,
            }));

            setError(err);
          }
        })
        .finally(() => {
          inProgressMap[key + depsAsString] = true;
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depsAsString, inProgressMap]);

  return { data, error };
};

export const useProducts = () => useGenericFetch("products");

export const useManufacturers = () => {
  const state = globalState();
  const { familyId } = state.get();

  const params = React.useMemo(() => ({ nodeId: familyId }), [familyId]);
  const { data } = useGenericFetch("manufacturers", params);

  return data ? { data: data.manufacturers } : { data };
};

export const useGroup = (nodeId) => {
  const params = React.useMemo(() => ({ nodeId }), [nodeId]);
  return useGenericFetch("group", params);
};

export const useType = (nodeId) => {
  const params = React.useMemo(() => ({ nodeId }), [nodeId]);
  return useGenericFetch("types", params);
};
